import React, {useState} from 'react';
import propTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import {theme} from '../../../themes/default-theme';
import RespImg from "../../ui/RespImg";
import Text from "../../typography";
import ReactHtmlParser from 'react-html-parser';
import LoaderIcon from '../../../assets/icons/loader.png';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`

`
const ModelImageWrapper = styled.div`
    ${theme.breakpoints.up("md")} {
        picture, img {
            max-width: 667px;
        }
        img {
            margin-bottom: 25px;
        }
    }

    ${theme.breakpoints.down("sm")} {
        picture, img {
            max-width: 257px;
            margin-left: auto;
            margin-right: auto;
        }
        img {
            margin-bottom: 15px;
        }
    }

`
const ImageTextContainer = styled.div`
    h3 {
        font-weight: 800;
        color: #010101;
    }
    > div {
        font-weight: 400;
        color: #758094;
    }
    ${theme.breakpoints.up("md")} {
        max-width: 667px;
        h3 {
            font-size: 22px;
            line-height: 22px;
            margin-bottom: 15px; 
        }
        > div {
            font-size: 16px;
            line-height: 23px;
        }
    }

    ${theme.breakpoints.down("sm")} {
        h3 {
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 7px; 
        }
        > div {
            font-size: 14px;
            line-height: 20px;
        }
    }
`
const ActiveImage = styled.div`
    ${props => props.loading ? `
        display: none;
    `:`
        display: block;
    `}
`
const Loader = styled.div`
    text-align: center;
    align-items: center;
    justify-content: center;
    > img {
        animation: ${rotate} 2s linear infinite;
    }
    ${theme.breakpoints.up('md')} {
        min-height: 200px;
    }
    ${theme.breakpoints.up('lg')} {
        min-height: 370px;
    }
    ${theme.breakpoints.down('sm')} {
        min-height: 170px;
    }
    ${props => props.loading ? `
        display: flex;
    `:`
        display: none;
    `}

`

const ModelImageText = (props) => {

 const {
    image,
    headline,
    introText
 } = props;

    const [loading, setLoading] = useState(true);

    const onLoad = () => {
        setLoading(false);
    };

  return (
    <>
        {props &&
        <Container>
                <ModelImageWrapper>
                    <Loader loading={loading}>
                        <img src={LoaderIcon} alt="loader" />
                    </Loader>
                    {
                        image &&
                        <ActiveImage onLoad={onLoad}>
                            <RespImg
                                // loading={loading}
                                {...image}
                            />
                        </ActiveImage>
                    }
                    <ImageTextContainer>
                        {
                            headline &&
                                <Text variant="h3" align={'center'} uppercase={true}>{headline}</Text>
                        }
                        {
                            introText &&
                                <Text variant="body2" align={'center'}>{ReactHtmlParser(introText)}</Text>
                        }
                    </ImageTextContainer>
                </ModelImageWrapper>
        </Container>
        }
    </>
  );
}

ModelImageText.propTypes = {
    image: propTypes.object,
    headline: propTypes.string,
    introText: propTypes.string
};

ModelImageText.defaultProps = {
    image: {},
    headline: null,
    introText: null
}

export default ModelImageText;